  var handle = window.productHandle;
var open3d= false;
  
const KonfigTracking = (() => {

  // ── KONFIGURATION ─────────────────────────────────────────
  const WP_URL  = 'https://dashboard.mirrored.pro/';
  const API_KEY = 'testkey';
  const KONFIG  = 'HTree PopUp '+handle; // ← pro Kunde anpassen
  const USER_ID = 52;            // ← WP User ID des Kunden

  // ── SESSION STATE ─────────────────────────────────────────
  const SESSION_ID    = 'sess-' + Math.random().toString(36).substr(2, 9);
  const SESSION_START = { time: null };
  let   _endFired     = false; // doppeltes Feuern verhindern

  // ── DEVICE ────────────────────────────────────────────────
  function getDevice() {
    const ua = navigator.userAgent;
    if (/iPhone|iPad|iPod/.test(ua)) return 'ios';
    if (/Android/.test(ua)) return 'android';
    return 'desktop';
  }

  // ── SEND ──────────────────────────────────────────────────
  function send(element_key, event_type, duration_ms = 0, cart_value = 0) {
    const payload = JSON.stringify({
      user_id:      USER_ID,
      konfigurator: KONFIG,
      element_key,
      event_type,
      duration_ms,
      cart_value,
      device:       getDevice(),
      page_url:     window.location.href,
      session_id:   SESSION_ID,
    });

    // fetch primär
    fetch(`${WP_URL}/wp-json/konfig/v1/track`, {
      method:  'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Konfig-Key': API_KEY,
      },
      body: payload,
    }).catch(() => {
      // Fallback: sendBeacon wenn fetch fehlschlägt
      navigator.sendBeacon(
        `${WP_URL}/wp-json/konfig/v1/track`,
        new Blob([payload], { type: 'application/json' })
      );
    });
  }

  // ── END SESSION ───────────────────────────────────────────
  function endSession() {
    // Doppeltes Feuern verhindern
    if (!SESSION_START.time || _endFired) return;
    _endFired = true;

    const duration_ms = Date.now() - SESSION_START.time;
    SESSION_START.time = null;

    const payload = JSON.stringify({
      user_id:      USER_ID,
      konfigurator: KONFIG,
      element_key:  'session:close',
      event_type:   'dwell',
      duration_ms:  duration_ms,
      cart_value:   0,
      device:       getDevice(),
      page_url:     window.location.href,
      session_id:   SESSION_ID,
    });

    // fetch primär
    fetch(`${WP_URL}/wp-json/konfig/v1/track`, {
      method:  'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Konfig-Key': API_KEY,
      },
      body: payload,
    }).catch(() => {
      // Fallback: sendBeacon
      navigator.sendBeacon(
        `${WP_URL}/wp-json/konfig/v1/track`,
        new Blob([payload], { type: 'application/json' })
      );
    });
  }

  // ── INIT ──────────────────────────────────────────────────
  function init() {
    SESSION_START.time = Date.now();
    _endFired          = false; // Reset falls init() erneut aufgerufen wird
    send('session:start', 'click');

    // Methode 1: Tab/Browser schließen, URL wechseln
    window.addEventListener('beforeunload', endSession, { once: true });

    // Methode 2: Tab wechseln, App minimieren (iOS zuverlässig)
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'hidden') {
        endSession();
      }
    }, { once: true });
  }

  // ── TRACK CLICK ───────────────────────────────────────────
  function track(category, value, cartValue = 0) {
    const element_key = ['addcart', 'ar:start', 'session:close'].includes(category)
      ? category
      : `${category}:${value}`;
    send(element_key, 'click', 0, cartValue);
  }

  // ── TRACK DWELL ───────────────────────────────────────────
  function trackDwell(category, value, startTime) {
    const ms = Date.now() - startTime;
    if (ms < 500) return; // unter 0.5s ignorieren
    send(`${category}:${value}`, 'dwell', ms);
  }

  // ── EXPORT ────────────────────────────────────────────────
  return { init, track, trackDwell, endSession };

})();

  

(function () {
  var root = document.currentScript
    ? document.currentScript.closest('[data-clx-gallery]')
    : document.querySelector('[data-clx-gallery]');
  if (!root) root = document.querySelector('[data-clx-gallery]');
  if (!root) return;
 
  var dialog  = root.querySelector('[data-dialog]');
  var openBtn = root.querySelector('[data-open]');
  var closeBtn = root.querySelector('[data-close]');
  var index = 0;
 
  /* ── Öffnen ── */
  if (openBtn) openBtn.addEventListener('click', function () {

    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', 'open');
   //initUI();
    KonfigTracking.init();
    if(window.fbq){
        fbq('trackCustom', 'ConfiguratorStart');
    }
    
     initFromUrl();
   
  });
 
  /* ── Schließen ── */
  function closeDialog() {
    if (dialog.open){ dialog.close(); KonfigTracking.endSession();
     //KonfigTracking.track('session:close', 'click');
    }
  }
 
  if (closeBtn) closeBtn.addEventListener('click', closeDialog);
 
  /* FIX: closeModal Button ist INNERHALB der IIFE, damit closeDialog erreichbar ist */
  var closeModalBtn = root.querySelector('#closeModal');
  if (closeModalBtn) closeModalBtn.addEventListener('click', closeDialog);
 
  /* Klick auf Backdrop schließt Dialog */
  dialog.addEventListener('click', function (e) {
    var rect = dialog.getBoundingClientRect();
    var inside = e.clientX >= rect.left && e.clientX <= rect.right
               && e.clientY >= rect.top  && e.clientY <= rect.bottom;
    if (!inside) closeDialog();
  });
 
  /* Tastatur */
  dialog.addEventListener('keydown', function (e) {
    if (e.key === 'Escape')     closeDialog();
    if (e.key === 'ArrowLeft')  index = Math.max(0, index - 1);
    if (e.key === 'ArrowRight') index = index + 1;
  });
 
})();


var IDs ={
  "H1":{
    "Black":{
      "SisalBlack":49984388366677,
      "SisalNatur":49984388333909,
    },
     "White":{
      "SisalBlack":49984388432213,
      "SisalNatur":49984388399445,
    },
     "Natural":{
      "SisalNatur":53529594528085,
      "SisalBlack":53777005969749,
    },
   
  },
    "H2":{
    "Black":{
      "SisalBlack":49967841902933,
      "SisalNatur":49983542722901,
    },
     "White":{
      "SisalBlack":49967841968469,
      "SisalNatur":49983542755669,
    },
     "Natural":{
      "SisalNatur":53529834488149,
      "SisalBlack":53777021272405,
    },
   
  },
    "H3":{
    "Black":{
      "SisalBlack":49967895314773,
      "SisalNatur":49967895347541,
    },
     "White":{
      "SisalBlack":49967895380309,
      "SisalNatur":49967895413077,
    },
     "Natural":{
      "SisalNatur":53529843401045,
       "SisalBlack":53777025499477,
    },
   
  },
    "H4":{
    "Black":{
      "SisalBlack":49968192553301,
      "SisalNatur":49968192586069,
    },
     "White":{
      "SisalBlack":49968192618837,
      "SisalNatur":49968192651605,
    },
     "Natural":{
      "SisalNatur":53529851363669,
      "SisalBlack":53777026974037,
    },
   
  },
  


}


var prodId = [];

var selection={
"color":"Black",
"sisal":"SisalBlack",
"size":"H3",
"price":0,
}

// Price map per size code
  const prices3D = { H1: '300,00 €', H2: '450,00 €', H3: '600,00 €', H4: '750,00 €' };

var mv= document.getElementById("mv");

  function select(el, valueId, groupId) {
    document.querySelectorAll(`#${groupId} .swatch`).forEach(s => s.classList.remove('swatch--active'));
    el.classList.add('swatch--active');
    document.getElementById(valueId).textContent = el.dataset.value;
    updateSummary();
    //console.log(el);

    if(groupId=="wood-swatches"){
      selection.color=document.querySelector('#wood-swatches .swatch--active').dataset.var;
      if(selection.color=="Natural"){
         mv.variantName=selection.color+"-"+selection.sisal;
          KonfigTracking.track('Holzfarbe', selection.color);
          getID();
      } else{    
      mv.variantName=document.querySelector('#wood-swatches .swatch--active').dataset.var 
           
                        KonfigTracking.track('Holzfarbe', selection.color);

     getID();
      }
  
    }else{
          
       selection.sisal= document.querySelector('#sisal-swatches .swatch--active').dataset.var;
 if(selection.color=="Natural"){
         mv.variantName=selection.color+"-"+selection.sisal;
          KonfigTracking.track('Sisal Farbe', selection.sisal);
             getID();
      } else{  
      mv.variantName=document.querySelector('#sisal-swatches .swatch--active').dataset.var;   
                        KonfigTracking.track('Sisal Farbe', selection.sisal);

  getID();
      }
    
    }

  
   
  }

  function selectSize(el) {

     //mv.setAttribute('reveal', 'manual');
    document.querySelectorAll('.size-btn').forEach(b => b.classList.remove('size-btn--active'));
    el.classList.add('size-btn--active');
    //console.log(el.dataset.code);
    //console.log("select size");
    selection.size = el.dataset.code;
 //KonfigTracking.track('Größe', selection.size);

    const label = `${el.dataset.code} · ${el.dataset.cm} CM`;
    document.getElementById('size-label').textContent = label;
    document.getElementById('viewer-badge').textContent = label;
    document.getElementById('viewer-size-num').textContent = el.dataset.cm;
    document.getElementById('price').textContent = prices3D[el.dataset.code];
    selection.price=parseFloat(prices3D[el.dataset.code].replace(/[^0-9,]/g, '').replace(',', '.'))

    updateSummary();

    setLadder();
      getID();

      if(open3d){
         KonfigTracking.track('Größe', selection.size);
        // console.log("tracksize");
      }
      open3d=true; // wird einmalig getriggert
  }

 

  
function setLadder() {
  mv.style.opacity = "0";
  mv.src = "https://mirrored.pro/wp-content/uploads/HTree/"+selection.size + ".glb";

  mv.addEventListener("load", () => {
    if (selection.color === "Natural") {
      mv.variantName = selection.color + "-" + selection.sisal;
      getID();
    } else {
      mv.variantName = selection.color;
      setTimeout(() => {
        mv.variantName = selection.sisal;
      }, 500);
    }

    setTimeout(() => {
      mv.style.opacity = "1";
    }, 500);
  }, { once: true });
  console.log(window.fbq)
}


 function updateSummary() {
    const wood  = document.getElementById('wood-value').textContent.toUpperCase();
    const sisal = document.getElementById('sisal-value').textContent.toUpperCase();
    const size  = document.getElementById('size-label').textContent;
    document.getElementById('summary-config').textContent = `${size} · ${wood} / SISAL ${sisal}`;
  }
  // ── AR Button ────────────────────────────────────────────────────
  // Mobile → activate model-viewer AR directly
  // Desktop → show QR modal
  const AR_URL = 'https://YOUR-AR-LINK.com'; // ← deine model-viewer / Scene Viewer URL

  function isMobile() {
    return /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
  }

  function handleAR() {
          KonfigTracking.track('ar:start', 'ar:start');
 if(window.fbq){
        fbq('trackCustom', 'ARStart');
    }
    if (isMobile()) {
      // Trigger model-viewer AR directly
      const mv = document.querySelector('model-viewer');
      if (mv && mv.canActivateAR) {
        mv.activateAR();
      } else {
        // Fallback: open AR link directly (Scene Viewer / Quick Look)
        window.location.href = AR_URL;
      }
    } else {
      // Desktop: show QR modal
       generateQR();
      document.getElementById('qr-modal').classList.add('open');
    }
  }

  function closeModal() {
    document.getElementById('qr-modal').classList.remove('open');
   
  }



  function closeQR(e) {
    // Close on backdrop click
    if (e.target === document.getElementById('qr-modal')) closeModal();
  }

  // ESC key closes modal
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') closeModal();
    KonfigTracking.endSession();
  });
  
   var productID;
  
function getID(){
 productID = IDs[selection.size][selection.color][selection.sisal];
  
  console.log(IDs[selection.size]);
   console.log(IDs[selection.size][selection.color]);
     console.log(IDs[selection.size][selection.color][selection.sisal]);

checkVariantAvailability(productID);
    }


  var butAddC = document.getElementById("addCart");

  
  butAddC.addEventListener("click",addItems1);
  
  var  formData ={
  'items': [ {
    'id': 49967895314773,
    'quantity': 1
     
    } ]
};

function addItems1() {
     KonfigTracking.track('addcart', 'addcart', selection.price);

    //console.log("additem " + selection.ProdVariant );
  formData.items[0].id=productID;
    //console.log("formData: "+ JSON.stringify(formData, null, 2))
  
// fügt in den Cart JS hinzu
fetch(window.Shopify.routes.root + 'cart/add.js', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  },



  
  body: JSON.stringify(formData)
})
.then(response => {
  return response.json();
})
.catch((error) => {
  console.error('Error:', error);
});

  

 // console.log("Added");

 
setTimeout(() => {
    window.location.href = 'https://htreestudio.com/cart';
}, "1000");



}

  
            function checkVariantAvailability(variantId) {
  fetch(`/variants/${variantId}.js`)
    .then(res => res.json())
    .then(variant => {
      if (variant.available) {
       // console.log('Variante verfügbar ✅');
        butAddC.innerHTML="Add to cart"
        butAddC.classList.remove('disabled');
        butAddC.disabled=false;
        // Hier Button aktivieren
        //document.querySelector('#add-to-cart-button').disabled = false;
      } else {
       // console.log('Variante NICHT verfügbar ❌');
        butAddC.innerHTML="Sold out"
       butAddC.disabled=true;
        butAddC.classList.add('disabled');
        // Hier Button deaktivieren
        //document.querySelector('#add-to-cart-button').disabled = true;
      }
    })
    .catch(err => {
      //console.error('Fehler beim Prüfen der Variante:', err);
      butAddC.innerHTML = "Sold out";
      butAddC.disabled = true;
      butAddC.classList.add('disabled');
    });
}

var variant3d;

function initFromUrl() {
  const params = new URLSearchParams(window.location.search);

  // Farben aus URL in selection übernehmen, falls vorhanden
  if (params.get('color')) selection.color = params.get('color');
  if (params.get('sisal')) selection.sisal = params.get('sisal');

  if (params.get('variant')){
    //console.log("insidavar");
    variant3d = params.get('variant');
    getInfoByID(variant3d);

        mv.style.opacity = "0";
    
    mv.variantName = selection.color;

    setTimeout(() => {
      mv.variantName = selection.sisal;

      setTimeout(() => {
       // console.log("opacity 1");
        mv.style.opacity = "1";
      }, 500);
    }, 500);

  } 

  // AR autostart
  if (params.get('startAR') === 'true') {
    document.getElementById("modal3d").click();

  activateSwatch('wood', selection.color);
  activateSwatch('sisal', selection.sisal);

    getID();
    setLadder();

    
  }
}

function getInfoByID(id) {
 // console.log("infobyid");
  for (const [size, colors] of Object.entries(IDs)) {
    for (const [color, sisalColors] of Object.entries(colors)) {
      for (const [sisalColor, variantId] of Object.entries(sisalColors)) {
        if (variantId === Number(id)) {
          console.log("found");
          //return { size, color, sisalColor };
          console.log(color + " "+ sisalColor);
          selection.color=color;
          selection.sisal=sisalColor;
          return;
        }
      }
    }
  }
 // console.log("none");
     selection.color="Black";
          selection.sisal="SisalBlack";
  // Fallback: color Black, sisalColor SisalBlack
  return 
}

var selection = {
  "color": "Black",
  "sisal": "SisalBlack",
  "size": "H3"
};

//initFromUrl();


function initUI(){


  //var handle = window.productHandle;

  //console.log(handle);

  if(handle=="h1-kratzbaum"){
    selection.size="H1";
    selection.price=300;
    document.querySelector('[data-code="H1"]').click();
  }
   if(handle=="h2-kratzbaum"){
    selection.size="H2"
     selection.price=450;
    document.querySelector('[data-code="H2"]').click();
  }
   if(handle=="H3-kratzbaum"){
    selection.size="H3"
     selection.price=600;
  document.querySelector('[data-code="H3]').click();
  }
   if(handle=="h4-kratzbaum"){
    selection.size="H4"
     selection.price=750;
    document.querySelector('[data-code="H4"]').click();
  }

}

initUI();
initFromUrl();

function activateSwatch(group, value) {
  const swatch = document.querySelector(
    `.swatch[data-group="${group}"][data-var="${value}"]`
  );
  if (swatch) swatch.click();
}



function generateQR() {
  const baseUrl = "https://htreestudio.com/products/"+selection.size+"-kratzbaum";
  const params = new URLSearchParams({
    color: selection.color,
    sisal: selection.sisal,
    startAR: 'true'
  });

  const url = `${baseUrl}?${params.toString()}`;

  document.getElementById('qr-code').innerHTML = '';

  new QRCode(document.getElementById('qr-code'), {
    text: url,
    width: 200,
    height: 200,
  });

  //console.log('QR-URL:', url);
}